import axios from "axios";
import { API_URL } from "../../../services/api";
import { getAuthItem } from "../../../utils/authStorage";
import { getApiErrorMessage } from "./utils/apiErrors";

const api = axios.create({
  baseURL: `${API_URL.replace(/\/+$/, "")}/hiring/portal`,
  timeout: Number(process.env.REACT_APP_HIRING_API_TIMEOUT_MS) || 60000,
});

api.interceptors.request.use(
  (config) => {
    const token = getAuthItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    error.userMessage = getApiErrorMessage(error);
    if (error.code === "ECONNABORTED") {
      console.error("Hiring portal request timeout:", error.config?.url);
    } else if (error.response) {
      console.error(
        "Hiring portal API error:",
        error.response.status,
        error.response.data
      );
    } else if (error.request) {
      console.error("No response from hiring portal:", error.config?.url);
    }
    return Promise.reject(error);
  }
);

export default api;
export { getApiErrorMessage };
